import React from 'react';
import { Col } from 'react-bootstrap';
import Particles from 'react-particles-js';
import bgImage from '../../images/portfolio-bg-light-1.png';
import HeaderBottom from '../HeaderBottom/HeaderBottom';
const Header = () => {
    const headerBottomStyles = {
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        // height: "90vh",
      };
    const params1={
        "particles": {
            "number": {
                "value": 10
            },
            "size": {
                "value": 3
            },
            "color": {
                "value": '#FF4C60'
            }
        },
        "interactivity": {
            "events": {
                "onhover": {
                    "enable": true,
                     "mode": "repulse"
                }
            }
        }
    };
    return (
        <div className="mb-5">
            <section 
            style={headerBottomStyles}
            className=" d-flex justify-content-center align-items-center mt-2">
                <Col xs={12} lg={4}>
                 <div className="d-flex flex-column">
                 <Particles className="mb-3" params={params1}/>
                 <Particles  params={params1}/>
                 </div>
                </Col>
                <Col xs={12} lg={4}>
                <HeaderBottom/> 
                </Col>
                <Col xs={12} lg={4}>
                <div className="d-flex flex-column">
                 <Particles className="mb-3" params={params1}/>
                 <Particles  params={params1}/>
                 </div>
                </Col>
            </section>
        </div>
    );
};

export default Header;